import '../App.css';
import React, { useEffect } from 'react'
import NavBar from '../Widgets/NavBar';
import Footer from '../Widgets/Footer';

export default function IntegratedProject() {
    useEffect(() =>{
        document.title = "Projetos"
    }, [])
    return (
        <div>
            <header className="py-5">
                <div className="container">
                    <div className="row">
                        <NavBar selected='projects-page'></NavBar>
                    </div>
                </div>
            </header>

            <section id="about" className="py-3">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="section-title">Blog/Reddit Website and Mobile App</h2>
                            <p>
                                This project was part of a class called Integrated Project. It was proposed by a local tech company to challenge students to improve their web, backend, and mobile programming skills.
                                <br />
                                It consists of a website for admin usage that includes a backoffice for management, a mobile application (Android) for users, and a database to store all data.
                            </p>
                            <p>
                                The design of the website and the mobile application was made by the whole group.
                            </p>
                            <p>
                                We used React, a JavaScript library, and Bootstrap, a CSS framework, to build the website. The mobile app was developed using Flutter while the backend for both applications was developed using Sequelize and Express.
                            </p>
                            <p>
                                The images below show the final result of the project. The first 3 images show the login page, the main page and the backoffice while the lower 3 show the mobile login page, the main page and a post made by a user.
                            </p>
                            <div className="image-gallery">
                                <div className="image-item">
                                    <a style={{cursor: "pointer"}} href="./Project1/Project1-1.png" target="_blank">
                                        <img src='/projects/Project1/Project1-1.png' className="responsive-image" alt="Project Screenshot 1"/>
                                    </a>
                                </div>
                                <div className="image-item">
                                    <a style={{cursor: "pointer"}} href="./Project1/Project1-2.png" target="_blank">
                                        <img src='/projects/Project1/Project1-2.png' className="responsive-image" alt="Project Screenshot 2"/>
                                    </a>
                                </div>
                                <div className="image-item">
                                    <a style={{cursor: "pointer"}} href="./Project1/Project1-3.png" target="_blank">
                                        <img src='/projects/Project1/Project1-3.png' className="responsive-image" alt="Project Screenshot 3"/>
                                    </a>
                                </div>
                            </div>
                            <div style={{height: "30px"}}>

                            </div>
                            <div className="image-gallery">
                                <div className="image-item-vertical">
                                    <a style={{cursor: "pointer"}} href="./Project1/Project1-4.jpg" target="_blank">
                                        <img src='/projects/Project1/Project1-4.jpg' className="responsive-image" alt="Project Screenshot 1"/>
                                    </a>
                                </div>
                                <div className="image-item-vertical">
                                    <a style={{cursor: "pointer"}} href="./Project1/Project1-5.jpg" target="_blank">
                                        <img src='/projects/Project1/Project1-5.jpg' className="responsive-image" alt="Project Screenshot 2"/>
                                    </a>
                                </div>
                                <div className="image-item-vertical">
                                    <a style={{cursor: "pointer"}} href="./Project1/Project1-6.jpg" target="_blank">
                                        <img src='/projects/Project1/Project1-6.jpg' className="responsive-image" alt="Project Screenshot 3"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <Footer></Footer>
        </div>
    )
}
